<mat-toolbar class="hdmui-level00" [ngClass]="{'hdmui-background-1' : (level | async) === 2}">
  <mat-menu #userMenu="matMenu" xPosition="before">
    @if (currentUser) {
      <mat-list>
        <mat-list-item>
          <div matListItemIcon class="hdmui-p-0">
            <hdmui-avatar
              class="hdmui-avatar-small"
              [fullName]="currentUser.name"
              [avatarUrl]="currentUser.avatarUrl"
            >
            </hdmui-avatar>
          </div>
          <h3 matListItemTitle>{{ currentUser.name }}</h3>
          <div matListItemLine>{{ currentUser.email }}</div>
        </mat-list-item>
      </mat-list>
    }
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="goToProfile()" id="CloudToolbarProfileLinkButton">
      <mat-icon svgIcon="hdmui:person"></mat-icon> {{ '*.profile' | translate}}
    </button>


    <mat-divider></mat-divider>
    <button mat-menu-item (click)="doLogout()" id="CloudToolbarLogoutButton">
      <mat-icon svgIcon="hdmui:power"></mat-icon> {{ '*.logout' | translate }}
    </button>
  </mat-menu>

  @if (showSideBarIcon  && ((level | async) === 1)) {
    <button mat-icon-button (click)="sidebarMenuClick()"
      id="CloudToolbarSidebarButton">
      <mat-icon svgIcon="hdmui:menueMain"></mat-icon>
    </button>
  }

  @if (((level | async) === 2)) {
    <button mat-icon-button (click)="back()" [matTooltip]="'*.back' | translate">
      <mat-icon svgIcon="hdmui:arrowClassic-L"></mat-icon>
    </button>
  }

  <mat-divider [vertical]="true"></mat-divider>
  <!--
  @if(appIcon){
    <div class="app-icon">
      <mat-icon [svgIcon]="appIcon" class="app-icon"></mat-icon>
    </div>
  }
  -->




<ng-content>
</ng-content>

<span class="spacer"></span>

<button mat-button [matMenuTriggerFor]="userMenu" [matTooltip]="buildTooltip(currentUser)"
  id="CloudToolbarProfileMenuButton">
  @if(currentUser){
    <hdmui-avatar
      class="hdmui-avatar-small"
      [fullName]="currentUser.name"
      [avatarUrl]="currentUser.avatarUrl"
    ></hdmui-avatar>
  }
</button>

@if (!mobileMode) {
  <img class="logo"
    src="assets/hdmui/iconsets/Logo-Icons/LOGO-HEIDELBERG-MULTICOLOR-NO-GRADIENT.svg" alt="Heidelberg Logo">
  }
  @if (mobileMode) {
    <img class="logo"
      src="assets/hdmui/iconsets/Logo-Icons/ICON-HEIDELBERG-MULTICOLOR-NO-GRADIENT.svg" alt="Heidelberg Logo">
    }
  </mat-toolbar>
